<template>
	<router-link v-if="isLocalHref" :to="href" class="app_link_a" @click.native="handleClick">
		<slot>{{ name }}</slot>
	</router-link>

	<a v-else-if="href" :href="href" target="_blank" class="app_link_a" @click="handleClick">
		<slot>{{ name }}</slot>
	</a>

	<a v-else href="javascript:void(0);" class="app_link_a" @click="handleClick">
		<slot>{{ name }}</slot>
	</a>
</template>

<script>
export default {
	name: "index",
	props: {
		name: {
			type: String,
			default: ""
		},

		href: {
			type: String,
			default: ""
		}
	},
	computed: {
		isLocalHref() {
			if(this.href) {
				return this.href.substr(0, 4) !== 'http';
			}
			return false
		},
	},
	methods: {
		handleClick() {
			this.$emit("click");
		}
	}
}
</script>

<style scoped>
.app_link_a {
	color: inherit;
}
</style>
